
import React, { useState } from 'react';
import { Table, TableBody, TableCaption, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card } from "@/components/ui/card";
import { DollarSign, Calendar, Check, User } from 'lucide-react';

// Mock data for demonstration
const mockPayouts = [
  {
    id: '1',
    date: 'April 15, 2025',
    amountDue: 245.50,
    amountPaid: 245.50,
    paymentBy: 'Direct Deposit',
    paymentReceived: true
  },
  {
    id: '2',
    date: 'March 15, 2025',
    amountDue: 178.25,
    amountPaid: 178.25,
    paymentBy: 'PayPal',
    paymentReceived: true
  },
  {
    id: '3',
    date: 'February 15, 2025',
    amountDue: 195.75,
    amountPaid: null,
    paymentBy: null,
    paymentReceived: false
  }
];

const PayoutReport = () => {
  const [payouts, setPayouts] = useState(mockPayouts);
  
  const handlePaymentReceived = (id: string, received: boolean) => {
    setPayouts(payouts.map(payout => 
      payout.id === id ? { ...payout, paymentReceived: received } : payout
    ));
  };
  
  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">Payout Report</h2>
      
      <Table>
        <TableCaption>Your payment history with newest payments at the top</TableCaption>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[120px]">
              <div className="flex items-center">
                <Calendar className="mr-2 h-4 w-4" />
                Date
              </div>
            </TableHead>
            <TableHead>
              <div className="flex items-center">
                <DollarSign className="mr-2 h-4 w-4" />
                Amount Due
              </div>
            </TableHead>
            <TableHead>
              <div className="flex items-center">
                <DollarSign className="mr-2 h-4 w-4" />
                Amount Paid
              </div>
            </TableHead>
            <TableHead>
              <div className="flex items-center">
                <User className="mr-2 h-4 w-4" />
                Payment Method
              </div>
            </TableHead>
            <TableHead className="w-[150px]">
              <div className="flex items-center">
                <Check className="mr-2 h-4 w-4" />
                Status
              </div>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {payouts.length > 0 ? (
            payouts.map((payout) => (
              <TableRow key={payout.id}>
                <TableCell>{payout.date}</TableCell>
                <TableCell>${payout.amountDue.toFixed(2)}</TableCell>
                <TableCell>{payout.amountPaid ? `$${payout.amountPaid.toFixed(2)}` : '-'}</TableCell>
                <TableCell>{payout.paymentBy || 'Pending'}</TableCell>
                <TableCell>
                  <span className={`px-2 py-1 rounded-full text-xs ${payout.paymentReceived ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                    {payout.paymentReceived ? 'Completed' : 'Pending'}
                  </span>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} className="text-center py-4 text-gray-500">
                No payout records found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Card>
  );
};

export default PayoutReport;
